import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { IExpectedNMEAConfig } from './expectedNMEA/IExpectedNMEAConfig'


export class IrisrawModExpectedNMEA extends IrisModContainer<IrisConfigContainer<IExpectedNMEAConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModExpectedNMEA.createIrisrawExpectedNMEAConfig)        
    }

    static createIrisrawModExpectedNMEA(datas:IIrisModContainerConstParam) {        
        return new IrisrawModExpectedNMEA(datas)
    }

    static createIrisrawExpectedNMEAConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<IExpectedNMEAConfig>(data)
    }

}